import moment from "moment";

/**
 * Default time-sliced x-axis strings for KPI line modals. The API may send its own label array instead
 * (same length as each plotted series); use that wherever `buildModalLineChartLabels(...)` is invoked today.
 */
/** X-axis categories for KPI line modals (Total sales / Customer / Product). */
export const KPI_MODAL_CHART_AXIS_MAX_POINTS = 12;

/**
 * D/M/YYYY labels for `[start,end]` inclusive, at most {@link KPI_MODAL_CHART_AXIS_MAX_POINTS} ticks.
 * — Span ≤ max points: one label per calendar day.
 * — Longer spans: exactly `maxPoints` contiguous day buckets (equitable partition; full range covered).
 *
 * @param {Date | null | undefined} start
 * @param {Date | null | undefined} end
 * @param {number} [maxPoints]
 * @returns {string[]}
 */
export function buildModalLineChartLabels(start, end, maxPoints = KPI_MODAL_CHART_AXIS_MAX_POINTS) {
  if (!start || !end) {
    return Array.from({ length: maxPoints }, (_, i) =>
      moment("2024-09-01").add(i, "days").format("D/M/YYYY"),
    );
  }
  const s = moment(start).startOf("day");
  const e = moment(end).startOf("day");
  const n = Math.max(1, e.diff(s, "days") + 1);
  const fmt = (d) => moment(d).format("D/M/YYYY");

  if (n <= maxPoints) {
    const labels = [];
    for (let i = 0; i < n; i += 1) {
      labels.push(fmt(moment(s).add(i, "days")));
    }
    return labels;
  }

  const labels = [];
  for (let b = 0; b < maxPoints; b += 1) {
    const bucketStartDay = Math.floor((b * n) / maxPoints);
    labels.push(fmt(moment(s).add(bucketStartDay, "days")));
  }
  return labels;
}
